import { useState } from "react";
import { GenerateHisToken, HIS_NATIONAL_ID_PARAM, HIS_TOKEN_PARAM } from "src/requests/his";
import "./style.css";

const HisTestPage = () => {
    const [nationalId, setNationalId] = useState("27012291401384");
    const [token, setToken] = useState("");
    const [iframeSrc, setIframeSrc] = useState("");
    const [logs, setLogs] = useState<string[]>([]);
    const [generating, setGenerating] = useState(false);
    const [userId, setUserId] = useState("11649")

    const log = (message: string) =>
        setLogs((prev) => [...prev, `${new Date().toLocaleTimeString()} - ${message}`]);

    const handleGenerate = () => {
        setGenerating(true);
        log("Requesting token from our system...");

        GenerateHisToken({ nationalId, userId })
            .then((result: any) => {
                const generatedToken = result?.data?.randomToken;
                setToken(generatedToken);
                setIframeSrc("");
                log(`Received token: ${generatedToken}`);

            })
            .finally(() => setGenerating(false));
    };

    const handleLoadIframe = () => {
        if (!token) return;
        log(`Loading his-embed page in iframe${nationalId ? ` with nationalId ${nationalId}` : ""}...`);
        const params = new URLSearchParams({ [HIS_TOKEN_PARAM]: token });
        if (nationalId) params.set(HIS_NATIONAL_ID_PARAM, nationalId);
        setIframeSrc(`${window.location.origin}${window.location.pathname}#/his-embed?${params.toString()}`);
    };

    return (
        <div className="his-test-page">
            <div className="his-test-header">
                <h1>HIS Integration Test Page</h1>
            </div>

            <div className="his-test-section">
                <div className="his-test-section-title">
                    <span className="his-test-step">1</span>
                    <h2>Simulate HIS: Generate Token</h2>
                </div>

                <div className="his-test-fields">
                    <label className="his-test-field">
                        <span>Patient national ID</span>
                        <input
                            type="text"
                            placeholder="Patient national ID"
                            value={nationalId}
                            onChange={(e) => setNationalId(e.target.value)}
                        />
                    </label>
                    <label className="his-test-field">
                        <span>User ID</span>
                        <input
                            type="text"
                            placeholder="User ID"
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                        />
                    </label>
                </div>

                <button className="his-test-btn" onClick={handleGenerate} disabled={generating}>
                    {generating ? "Generating..." : "Generate Token"}
                </button>

                {token && (
                    <div className="his-test-result">
                        <span className="his-test-result-label">Token</span>
                        <code className="his-test-token">{token}</code>
                    </div>
                )}
            </div>

            <div className="his-test-section">
                <div className="his-test-section-title">
                    <span className="his-test-step">2</span>
                    <h2>Simulate iframe embed</h2>
                </div>

                <button className="his-test-btn" onClick={handleLoadIframe} disabled={!token || !nationalId || !userId}>
                    Load in iframe
                </button>

                {iframeSrc && (
                    <div className="his-test-result">
                        <span className="his-test-result-label">Iframe link</span>
                        <code className="his-test-token">{iframeSrc}</code>
                    </div>
                )}

                {iframeSrc && (
                    <iframe title="his-embed-preview" src={iframeSrc} className="his-test-iframe" />
                )}
            </div>

            <div className="his-test-section">
                <div className="his-test-section-title">
                    <h2>Log</h2>
                </div>
                <ul className="his-test-log">
                    {logs.length === 0 && <li className="his-test-log-empty">No activity yet</li>}
                    {logs.map((entry, index) => (
                        <li key={index}>{entry}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default HisTestPage;
